import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalAddress from './modal-address/modal-address.view.html';

let inject = [
    '$scope',
    'TunnelService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    'CartService',
    'SessionService',
    'ngAuthSettings',
    '$window',
    '$stateParams',
    'AddressService'
];

class TunnelController {
    constructor($scope,
                TunnelService,
                $state,
                $rootScope,
                SharedService,
                $uibModal,
                $timeout,
                CartService,
                SessionService,
                ngAuthSettings,
                $window,
                $stateParams,
                AddressService) {

        this.addressService = AddressService;
        this.userDirections = [];
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.CartService = CartService;
        this.ngAuthSettings = ngAuthSettings;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.SessionService = SessionService;
        this.$uibModal = $uibModal;
        this.TunnelService = TunnelService;
        this.SharedService = SharedService;
        this.registerInfo = true;
        let quoteCartSeller = this.SessionService.get('quoteCartSeller') || null;
        this.quoteCartSeller = quoteCartSeller;
        this.totalItemsQuoteValueSeller = 0;
        if (quoteCartSeller) {
            this.totalItemsQuoteValueSeller = quoteCartSeller.totalItemsQuoteValueSeller;
        }
        this.tunnelStep = 1;
        this.location = {};
        this.tunnelStep2FormData = {};
        this.cart = null;
        this.savingTunnelData = false;
        this.savingOrder = false;
        this.savedTunnelData = false;
        this.errorSavingTunnelData = '';
        this.tunnelStep2FormData.contactMovilIndicative =57;
        this.countriesBilling = {};
        this.loadingCountriesBilling = false;
        this.loadedCountriesBilling = false;
        this.statesBilling = {};
        this.loadingStatesBilling = false;
        this.loadedStatesBilling = false;
        this.citiesBilling = {};
        this.loadingCitiesBilling = false;
        this.loadedCitiesBilling = false;
        this.loadingSavingOrder = false;
        this.orderSaved = false;
        this.allowGuestInTunnel = this.$rootScope.allowGuestInTunnel;
        this.errorSavingOrder = false;
        this.messageSavingTheOrder = '';
        this.errorsDataSavingOrder = [];
        this.initLocationInfoLoaded = false;
        this.orderIdSaved = 0;
        this.cartOrderCreated = false;
        this.cartQuoteCreated = false;
        this.tunnelDataForm = {};
        this.tunnelDataForm.loadingCartInfo = false;
        this.tunnelDataForm.loadedCartInfo = false;
        this.hideEmptyCartAfterTunel = false;
        this.loadingTunel=true;
        this.emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,5}$';

        this.showBottomInfo = __env.clientName === 'laskin';
        this.cityId = null;
    }

    $onInit() {
        this.getCart();
    }

    getCart(){
      let cartId = this.SessionService.get('cartId') || '';
      let userId = '';
      try {
        userId = this.shCtrl.globals.currentUser.userId;
      }
      catch (e) {
          console.log("errors",e);
      }
      let clientPriceListName = '';
      try {
        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
      } catch (e) {
      }
      this.CartService.getCart(cartId, userId, clientPriceListName, true).then(response => {

        this.cart = response;
        console.log(response);
        this.Products = [];
        if (response.itemsCanastaUsuario.length) {
          response.itemsCanastaUsuario.forEach((valFor) => {
            this.Products.push(
              {
                "item_id": valFor.id,
                "item_name": valFor.name,
                "price": valFor.price,
                "category": valFor.category.slug,
                "quantity": valFor.quantity,
              }
            )
          });
        }
        this.$window.dataLayer.push({
            'event': 'add_shipping_info',
            'ecommerce': {
              items: {
                  products: this.Products
             }
            }
          });
        this.tunnelDataForm.loadingCartInfo = true;
        this.tunnelDataForm.loadedCartInfo = false;
        this.$rootScope.orderIdInsideTunnel = this.$stateParams.orderId;
        this.loadingTunel=false;
        if (!this.$rootScope.orderIdInsideTunnel) {
          let cart = this.cart;
          if (cart) {
            if (!cart.items.length) return this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
            this.cityId = cart.cartOrderData.location.city.id;
            this.getAddress('',this.cityId);

            try {
              this.isUserLogged = !!this.shCtrl.globals.currentUser.username;
            }
            catch (e) {

              if (this.$rootScope.allowGuestInTunnel) {
                // Do nothing
                this.tunnelDataForm.loadingCartInfo = false;
                this.tunnelDataForm.loadedCartInfo = true;
                return false;
              } else {
                if (this.ngAuthSettings.site.config.data.tunnel.allowQuotesNoLogin &&
                  cart.order.totalItemsToQuote === cart.items.length) {
                  // Do nothing
                  this.isUserLogged = true;
                } else {
                  // window.location.assign(config.env.basePath + '/#/login');
                  this.$rootScope.showModalLoginAfterTunnel = true;
                  this.$state.go('home.login');
                  this.$timeout(() => {
                    this.$state.reload();
                  }, 3000);
                  return false;
                }
              }
            }
          }

          this.tunnelDataForm.loadingCartInfo = false;
          this.tunnelDataForm.loadedCartInfo = true;
        }
        // When the order exist
        else if (!this.tunnelDataForm.loadedCartInfo) {
          try {
            this.isUserLogged = !!this.shCtrl.globals.currentUser.username;
            this.tunnelDataForm.loadedCartInfo = true;
            this.tunnelDataForm.loadingCartInfo = false;

            this.getPayMethodsTunnel();
            let url = this.ngAuthSettings.config.env.apiEndPoint +
              this.ngAuthSettings.config.paths.getCart +
              this.$rootScope.orderIdInsideTunnel +
              '&userId=' + '' +
              '&isOrder=' + '1';
            this.CartService.getCart(cartId, userId, clientPriceListName, true, url).then(response => {
              this.cart = response;
            }).catch(reason => {

            });
          } catch (e) {
            this.$rootScope.showModalLoginAfterTunnel = true;
            this.$state.go('home.login');
            this.$timeout(() => {
              this.$state.reload();
            }, 3000);
            return false;
          }

        }
      }).catch(() => {
        this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
      });
    }

    getAddress(id=null, idCity = null) {
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }

        this.addressService.getAllDirections(userId, idCity).then(response => {

            if (!response.error) {
                this.userDirections = [];
                angular.forEach(response.data, (value, key) => {
                    value.principal = value.principal === 1;
                    this.userDirections.push(value);
                });
                if (id){
                    this.tunnelStep2FormData.contactAddressDeliveryId = id.toString();
                    this.copyDataIntoBilling('address', this.tunnelStep2FormData.contactAddressDeliveryId);
                }
            }
            this.getAllCartOrderInfo();

        });


    }

    openAddressModal() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalAddress,
            controller: 'ModalAddressController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                cartData: () => this.cart,
                shCtrl: () => this.shCtrl
            }
        });
        modalInstance.result.then(result => {
            this.getAddress(result);
        }).catch(error => {
        });
    }

    copyDataIntoBilling(fieldName, delivery) {
        if (fieldName === 'neighborhood') {
            this.tunnelStep2FormData.contactNeighborhoodBilling = delivery;
        }
        else if (fieldName === 'building') {
            this.tunnelStep2FormData.contactBuildingBilling = delivery;
        }
        else if (fieldName === 'aparment') {
            this.tunnelStep2FormData.contactAparmentBilling = delivery;
        }
        else if (fieldName === 'address') {
             this.userDirections.forEach((sucursal, key) =>{
                if(sucursal["id"] == delivery){
                    this.tunnelStep2FormData.contactAddressBilling = sucursal["direccion"];
                    this.tunnelStep2FormData.contactAddressDelivery = sucursal["direccion"];
                }
             });
            //  this.tunnelStep2FormData.contactAddressBilling = delivery;
            //  this.tunnelStep2FormData.contactAddressDelivery =  delivery;
        }
        else if (fieldName === 'branchOffice') {
            if (delivery) {
                this.tunnelStep2FormData.branchOffice = 0;
                this.cart.tunnel.operatingCentersAddresses.forEach((sucursal, key) => {
                    if (sucursal['address'] === this.tunnelStep2FormData.contactAddressBilling) {
                        this.tunnelStep2FormData.branchOffice = sucursal['id'];
                    }
                });
            }
        }
    }

    getAllCartOrderInfo() {

        if (!this.initLocationInfoLoaded) {
            let cart = this.cart;
            // Set info data based on cart info
            this.contactCountryDelivery = this.cart.order.location.country.name.toString();
            let stateName = this.cart.order.location.state.name.toString();
            let cityName = this.cart.order.location.city.name.toString();

            let operatingCentersAddresses = this.userDirections;

            this.contactStateDelivery = stateName;
            this.contactCityDelivery = cityName;
            this.payMethod = this.cart.order.payment.name.toString();
            // this.$window.dataLayer.push({
            //   'event': 'checkoutOption',
            //   'ecommerce': {
            //     'checkout_option': {
            //       'actionField': {'step': 2, 'option': this.cart.order.payment.name.toString()}
            //     }
            //   }
            // });
            this.tunnelStep2FormData.contactBuildingDelivery = cart.tunnel.contactBuildingDelivery;
            this.tunnelStep2FormData.contactBuildingBilling = cart.tunnel.contactBuildingBilling;
            this.tunnelStep2FormData.contactAparmentDelivery = cart.tunnel.contactAparmentDelivery;
            this.tunnelStep2FormData.contactAparmentBilling = cart.tunnel.contactAparmentBilling;
            this.tunnelStep2FormData.contactNeighborhoodDelivery = cart.tunnel.contactNeighborhoodDelivery;
            this.tunnelStep2FormData.contactNeighborhoodBilling = cart.tunnel.contactNeighborhoodBilling;
            /*try {
                if (this.shCtrl.globals.currentUser.isB2B) {
                    this.tunnelStep2FormData.contactAddressDelivery = this.shCtrl.globals.currentClient.operatingCenter.address;
                } else {
                    this.tunnelStep2FormData.contactAddressDelivery = cart.tunnel.contactAddressDelivery;
                }
            } catch (ex) {
                this.tunnelStep2FormData.contactAddressDelivery = cart.tunnel.contactAddressDelivery;
            }*/
            this.tunnelStep2FormData.contactAddressBilling = cart.tunnel.contactAddressBilling;
            this.tunnelStep2FormData.contactProgrammedDelivery = cart.tunnel.contactProgrammedDelivery;


            this.tunnelStep2FormData.contactName = cart.cartTunnelDataInfo.contactName;
            this.tunnelStep2FormData.contactPhone = cart.cartTunnelDataInfo.contactTelefono;
            this.tunnelStep2FormData.contactMovil = cart.cartTunnelDataInfo.contactTelefonoMovil;
            this.tunnelStep2FormData.contactMail = cart.cartTunnelDataInfo.contactEmail;
            this.tunnelStep2FormData.contactPhoneIndicativeCity = cart.cartTunnelDataInfo.contactTelefonoIndiCiudad;
            this.tunnelStep2FormData.contactMovilIndicative = cart.cartTunnelDataInfo.contactTelefonoMovilIndi;
            this.tunnelStep2FormData.contactPhoneIndicativeCountry = cart.cartTunnelDataInfo.contactTelefonoIndiPais;

          try {
                this.tunnelStep2FormData.contactMail = this.shCtrl.globals.currentUser.contactEmail;
            } catch (e) {
            }
            //

            try {
                if (operatingCentersAddresses.length === 1) {
                    this.tunnelStep2FormData.contactAddressDelivery = operatingCentersAddresses[0]['direccion'];
                    this.tunnelStep2FormData.contactAddressBilling = operatingCentersAddresses[0]['direccion'];
                } else if (operatingCentersAddresses.length) {
                    this.tunnelStep2FormData.contactAddressDelivery = operatingCentersAddresses.filter((val) => {
                        return val.principal;
                    })[0].direccion;
                }
            } catch (e) {}

            /*if(!operatingCentersAddresses.length && $rootScope.isClientB2B()) {
                this.tunnelStep2FormData.contactAddressDelivery = '';
            }*/

            // Get the billing location info
            this.TunnelService.getCountriesBilling().then(response => {
                this.countriesBilling = response.data;
                let countryId = this.cart.order.billing.country.id.toString();
                this.TunnelService.getStatesBilling(countryId).then(response => {
                    this.statesBilling = response.data;
                    let stateId = this.cart.order.billing.state.id.toString();
                    this.TunnelService.getCitiesBilling(stateId).then(response => {
                        this.citiesBilling = response.data;
                        this.$timeout(() => {
                            this.tunnelStep2FormData.contactCountryBilling = this.cart.order.billing.country.id.toString();
                            this.tunnelStep2FormData.contactStateBilling = this.cart.order.billing.state.id.toString();
                            this.tunnelStep2FormData.contactCityBilling = this.cart.order.billing.city.id.toString();
                            this.initLocationInfoLoaded = true;
                        }, 300);
                    }).catch(reason => {
                        let options = {
                            title: '',
                            isHtml: false,
                            content: reason,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    });
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }).catch(reason => {
                let options = {
                    title: '',
                    isHtml: false,
                    content: reason,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    getPayMethodsTunnel() {
        if (!this.paymentMethodsTunnel) {
            this.TunnelService.getPayMethods().then(response => {
                this.paymentMethodsTunnel = response;
                if (this.paymentMethodsTunnel.length === 1) {
                    this.paymentMethodTunnel = this.paymentMethodsTunnel[0]['id'];
                }
            }).catch(reason => {

            });
        }
    }

    saveTunnel(tunnelStep2Form, alsoCreateOrder2) {
        let alsoCreateOrder = alsoCreateOrder2 || false;
        if (this.$rootScope.orderIdInsideTunnel) {
            this.savingTunnelData = false;
            this.savedTunnelData = true;
            this.tunnelStep = 3;
        } else if (tunnelStep2Form.$valid) {
            let cartId = this.SessionService.get('cartId') || '';
            let globals = this.shCtrl.globals;
            if (this.shCtrl.globalParams.solicitarInfoTransporte) {
                if (cartId) {
                    this.TunnelService.updateDespachoPedido(this.cart.order.vehiculo_transporte).then(response => {
                        if (!response.error) {
                            this.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
                        } else {
                            alert("Error al guardar informacion del conductor, verifique.");
                        }
                    }).catch(reason => {
                        this.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
                    });
                }
            } else {
                this.saveTunnelOkey(tunnelStep2Form, alsoCreateOrder);
            }
        } else {
             var validations=[];
            for (var prop in this.tunnelStep2Form.$error) {
                if(prop!='undefinded'){
                    angular.forEach(this.tunnelStep2Form.$error[prop], function (field) {
                        /* console.log('Campos',field.$$attr); */
                        if(field && field.$$attr.mvalid){
                            /* if(field.$$attr.$$element[0].value.length > 0){ */
                                validations.push('<li>' + field.$$attr.mvalid + '('+ field.$$attr.$$element[0].validationMessage +')' + '</li>' );
                            /* }else{
                                validations.push('<li>' + field.$$attr.mvalid + '</li>' );
                            } */
                        }
                    });
                }

            }

            var b = validations.reduce(function(p,c,i,validations){
                if (p.indexOf(c) == -1) p.push(c);
                else p.push('')
                return p;
            }, [])
          let options = {
            title: 'Faltan algunos datos por diligenciar...',
            isHtml: true,
            content: `
                    <div>
                      <p>
                        Para continuar con este proceso debes diligenciar los siguientes datos:
                      </p>
                      <ul style="margin-top: 10px;list-style: inherit;margin-left: 30px;">
                        ${b.join("")}
                      </ul>
                    </div>
                  `,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options, "active");
        }
    }

    saveTunnelOkey(tunnelStep2Form, alsoCreateOrder) {
        this.savingTunnelData = true;
        this.savedTunnelData = false;
        this.errorSavingTunnelData = '';

        this.tunnelStep2FormData.cartId = this.cart.cartId;
        this.tunnelStep2FormData.userId = '';

        if (this.shCtrl.globals) {
            try {
                this.tunnelStep2FormData.userId = this.shCtrl.globals.currentUser.userId;
            } catch (e) {
            }
        }

        this.tunnelStep2FormData.allowGuestInTunnel = this.$rootScope.allowGuestInTunnel;
        this.TunnelService.saveCartTunnelData(this.tunnelStep2FormData).then(response => {
            this.savingTunnelData = false;
            if (!response.error) {
                this.savedTunnelData = true;
                this.tunnelStep = 3;
                if (alsoCreateOrder) {
                    // showModalRespuestaCreacionOrden();
                    this.saveOrder();
                }
            } else {
                this.savedTunnelData = false;
                this.errorSavingTunnelData = response.message;
            }
        });

    }

    saveOrder() {

        this.loadingSavingOrder = true;
        this.orderSaved = false;
        this.errorSavingOrder = false;
        this.messageSavingTheOrder = '';
        this.errorsDataSavingOrder = [];

        let cartId = this.SessionService.get('cartId') || '';

        if (cartId) {
            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {
            }

            let sellerId = '';
            try {
                sellerId = this.shCtrl.globals.currentUser.sellerId;
            }
            catch (e) {
            }

            let orderOnlyToQuote = '';
            if (this.ngAuthSettings.site.config.data.tunnel.allowQuotesNoLogin &&
                this.cart.order.totalItemsToQuote === this.cart.items.length) {
                orderOnlyToQuote = 1;
            }
            // Get the contact mail
            let contactMail = '';
            try {
                contactMail = this.tunnelStep2FormData.contactMail;
            }
            catch (e) {
            }

            // Get the type and number id
            let contactTypeId = '';
            let contactNumberId = '';
            try {
                contactTypeId = this.tunnelStep2FormData.contactTypeId;
                contactNumberId = this.tunnelStep2FormData.contactNumberId;
            }
            catch (e) {
            }
            // Client price list
            let clientPriceList = '';
            try {
                clientPriceList = this.quoteCartSeller.clientPriceList;
            } catch (e) {
            }
            // Send the request
            this.TunnelService.saveOrder({
                'cartId': cartId,
                'userId': userId,
                'sellerId': sellerId,
                'orderOnlyToQuote': orderOnlyToQuote,
                'contactMail': contactMail,
                'contactTypeId': contactTypeId,
                'contactNumberId': contactNumberId,
                'quoteCartSeller': this.quoteCartSeller,
                'quoteCartSellerPriceListName': clientPriceList
            }).then(response => {
                this.loadingSavingOrder = false;
                if (!response.error) {
                    this.orderSaved = true;
                    this.orderIdSaved = response.data.orderId;
                    this.SessionService.remove('quoteCartSeller');
                    this.SessionService.remove('tunnelPayMethod');
                    this.SessionService.remove('tunnelCity');
                    this.messageSavingTheOrder = 'El pedido ha sido realizado exitosamente.';
                    $('div.modal-backdrop').remove();
                    if (this.cart.order.totalItemsToQuote !== this.cart.items.length) {
                        // Se limpia el carrito
                        this.SessionService.put('cartId', '');
                        this.cart = {};
                        this.CartService.clearLocalCart();
                        this.$scope.$emit('onUpdateCart');
                        this.cartOrderCreated = true;
                        let orderId = response.data.orderId;

                        if (this.ngAuthSettings.site.config.data.tunnel.hasGangway) {
                            // window.location = config.env.apiEndPoint + '/order/pay-gate?id='+this.orderIdSaved;
                            // this.hideEmptyCartAfterTunel = true;
                            this.$state.go('home.confirmationOrder', {orderId: this.orderIdSaved, resolve: false});
                            this.hideEmptyCartAfterTunel = true;
                        }
                        else {
                            this.$state.go('home.orderDetail', {orderId: this.orderIdSaved});
                            this.hideEmptyCartAfterTunel = true;
                        }
                    } else {
                        // Se limpia el carrito
                        this.SessionService.put('cartId', '');
                        this.cart = {};
                        this.CartService.clearCart();
                        this.$scope.$emit('onUpdateCart');
                        this.cartQuoteCreated = true;
                        this.$state.go('home.quoteDetail', {quoteId: response.data.quoteId});
                    }
                } else {
                    if (response.errorCode === 'CANASTA-NO-EXISTE') {
                        response.message = 'Se ha presentado un problema interno en la aplicación. ' +
                            'La canasta ha sido eliminada. En un momento será redirigido ' +
                            'la página de inicio.';
                        // Se limpia el carrito
                        this.SessionService.put('cartId', '');
                        this.cart = {};
                        this.CartService.clearCart();
                        this.$scope.$emit('onUpdateCart');
                        this.$timeout(function () {
                            this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                        }, 3000);
                    }

                    this.errorSavingOrder = true;
                    this.messageSavingTheOrder = response.message;
                    this.errorsDataSavingOrder = response.errorsMessages;

                    let options = {
                        title: '',
                        isHtml: false,
                        content: this.messageSavingTheOrder,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    this.getCart();
                    this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                }
            }).catch(reason => {

                this.loadingSavingOrder = false;
                this.errorSavingOrder = true;
                this.messageSavingTheOrder = 'Ha ocurrido un error al realizar el pedido.' +
                    ' Por favor vuelva a intentarlo más tarde.';
            });
        }
        else {
            alert('No existe una canasta');
        }
    }

    sendOrderToGanway(tunnelStep2Form) {
        if (this.$rootScope.orderIdInsideTunnel) {
            if (tunnelStep2Form.$valid && this.paymentMethodTunnel) {
                if (this.ngAuthSettings.site.config.data.tunnel.hasGangway) {
                    let url = config.env.apiEndPoint +
                        '/order/pay-gate?id=' + this.$rootScope.orderIdInsideTunnel +
                        '&paymentMethodTunnel=' + this.paymentMethodTunnel;
                    this.$rootScope.orderIdInsideTunnel = '';
                    $window.location = url;
                } else {
                    this.$rootScope.orderIdInsideTunnel = '';
                    // $location.path('/pedido-creado/' + this.orderIdSaved);
                    this.$state.go('home.orderDetail', {orderId: this.orderIdSaved});
                }
            } else {
                angular.forEach(tunnelStep2Form.$error.required, field => {
                    field.$setDirty();
                });
            }

        }
    }

    registerData(value){

      if(__env.adaptative){
        value=!this.registerInfo;
      }
      if(value){
        this.tunnelStep2FormData.contactName = this.cart.cartTunnelDataInfo.contactName;
        this.tunnelStep2FormData.contactPhone = this.cart.cartTunnelDataInfo.contactTelefono;
        this.tunnelStep2FormData.contactMovil = this.cart.cartTunnelDataInfo.contactTelefonoMovil;
        this.tunnelStep2FormData.contactMail = this.cart.cartTunnelDataInfo.contactEmail;
        this.tunnelStep2FormData.contactPhoneIndicativeCity = this.cart.cartTunnelDataInfo.contactTelefonoIndiCiudad;
        this.tunnelStep2FormData.contactMovilIndicative = this.cart.cartTunnelDataInfo.contactTelefonoMovilIndi;
        this.tunnelStep2FormData.contactPhoneIndicativeCountry = this.cart.cartTunnelDataInfo.contactTelefonoIndiPais;


      }else{
        this.tunnelStep2FormData.contactName = null;
        this.tunnelStep2FormData.contactPhone = null;
        this.tunnelStep2FormData.contactMovil = null;
        this.tunnelStep2FormData.contactMail = null;
        this.tunnelStep2FormData.contactMovilIndicative =null;
        this.tunnelStep2FormData.contactPhoneIndicativeCity = null;
        this.tunnelStep2FormData.contactPhoneIndicativeCountry =null;
      }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    onPolicyChange() {
      this.tunnelStep2FormData.policies = true;
    };
}


TunnelController.$inject = inject;

export default TunnelController;




// WEBPACK FOOTER //
// ./www/components/tunnel/tunnel.controller.js